import { useContext } from 'react';
import { NavLink } from 'react-router-dom';
import { StylingContext, useAuthContext } from '../../store/Contexts';
import './Navbar.css';
import { SecurityAttributes } from '../../utils/data/enums';
import { ROUTES } from '../../constants/routes';
import { getText } from '../../i18n';

function MultiTenantMenu() {
    const { hasSecurityAttribute } = useAuthContext();
    const { currentStyling } = useContext(StylingContext);

    const toggleDropdown = event => {
        event.currentTarget.lastChild.classList.toggle('bi-chevron-down');
        event.currentTarget.lastChild.classList.toggle('bi-chevron-up');
        var dropdownContent = event.currentTarget.nextElementSibling;
        dropdownContent.style.display =
            dropdownContent.style.display === 'block' ? 'none' : 'block';
    };

    return (
        <>
            <NavLink
                to={ROUTES.ROOT}
                className={`${currentStyling.navbarLinkClass}`}
            >
                <i
                    className={`bi bi-house-door-fill`}
                    style={{ color: currentStyling.accessoriesFg1 }}
                ></i>
                <div className={`text ${currentStyling.navbarTextClass}`}>
                    {getText('msg_70f8bb9a8a53')}
                </div>
            </NavLink>

            {hasSecurityAttribute([
                SecurityAttributes.UserAccountFullAccess,
                SecurityAttributes.UserAccountReadOnly,
            ]) && (
                <NavLink
                    to={ROUTES.USER_ACCOUNTS}
                    className={`${currentStyling.navbarLinkClass}`}
                >
                    <i
                        className={`bi bi-people`}
                        style={{ color: currentStyling.accessoriesFg1 }}
                    ></i>
                    <div className={`text ${currentStyling.navbarTextClass}`}>
                        {getText('msg_57f2b181d0a5')}
                    </div>
                </NavLink>
            )}

            {hasSecurityAttribute([
                SecurityAttributes.ClientFullAccess,
                SecurityAttributes.ClientReadOnly,
            ]) && (
                <NavLink
                    to={ROUTES.CLIENTS}
                    className={`${currentStyling.navbarLinkClass}`}
                >
                    <i
                        className={`bi bi-buildings`}
                        style={{ color: currentStyling.accessoriesFg1 }}
                    ></i>
                    <div className={`text ${currentStyling.navbarTextClass}`}>
                        {getText('msg_28e22fe3dde5')}
                    </div>
                </NavLink>
            )}

            {hasSecurityAttribute([
                SecurityAttributes.MultiTenantPortalTemplatesFullAccess,
                SecurityAttributes.MultiTenantPortalTemplatesReadOnly,
                SecurityAttributes.MultiTenantNotificationTemplatesFullAccess,
                SecurityAttributes.MultiTenantNotificationTemplatesReadOnly,
            ]) && (
                <>
                    <button
                        className="dropdown-btn"
                        onClick={event => toggleDropdown(event)}
                    >
                        <i className={`bi bi-clipboard2`}></i>
                        <div className={`text`}>
                            {getText('msg_f25b700ed9f0')}
                        </div>
                        <i className="bi bi-chevron-down dropdown-chevron" />
                    </button>
                    <div className="dropdown-container">
                        {hasSecurityAttribute([
                            SecurityAttributes.MultiTenantPortalTemplatesFullAccess,
                            SecurityAttributes.MultiTenantPortalTemplatesReadOnly,
                        ]) && (
                            <NavLink
                                to={ROUTES.TEMPLATES}
                                className={`${currentStyling.navbarLinkClass}`}
                            >
                                <div
                                    className={`text ${currentStyling.navbarTextClass}`}
                                >
                                    {getText('msg_a0c88242e813')}
                                </div>
                            </NavLink>
                        )}
                        {hasSecurityAttribute([
                            SecurityAttributes.MultiTenantNotificationTemplatesFullAccess,
                            SecurityAttributes.MultiTenantNotificationTemplatesReadOnly,
                        ]) && (
                            <NavLink
                                to={ROUTES.NOTIFICATION_TEMPLATES}
                                className={`${currentStyling.navbarLinkClass}`}
                            >
                                <div
                                    className={`text ${currentStyling.navbarTextClass}`}
                                >
                                    {getText('msg_753a22b2eb61')}
                                </div>
                            </NavLink>
                        )}
                    </div>
                </>
            )}

            {hasSecurityAttribute([
                SecurityAttributes.GlobalAssetsFullAccess,
                SecurityAttributes.AssetLibraryReadOnly,
            ]) && (
                <NavLink
                    to={ROUTES.GLOBAL_ASSETS}
                    className={`${currentStyling.navbarLinkClass}`}
                >
                    <i
                        className={`bi bi-book`}
                        style={{ color: currentStyling.accessoriesFg1 }}
                    ></i>
                    <div className={`text ${currentStyling.navbarTextClass}`}>
                        {getText('msg_501c99a12432')}
                    </div>
                </NavLink>
            )}

            {hasSecurityAttribute([
                SecurityAttributes.AdminSecurityRolesFullAccess,
                SecurityAttributes.AdminSecurityRolesReadOnly,
            ]) && (
                <>
                    <button
                        className="dropdown-btn"
                        onClick={event => toggleDropdown(event)}
                    >
                        <i
                            className={`bi bi-gear`}
                            style={{ color: currentStyling.accessoriesFg1 }}
                        />
                        <div className={`text`}>
                            {getText('msg_754164850f38')}
                        </div>
                        <i className="bi bi-chevron-down dropdown-chevron" />
                    </button>
                    <div className="dropdown-container">
                        {hasSecurityAttribute([
                            SecurityAttributes.AdminSecurityRolesFullAccess,
                            SecurityAttributes.AdminSecurityRolesReadOnly,
                        ]) && (
                            <NavLink
                                to={ROUTES.SECURITY_ROLES}
                                className={`${currentStyling.navbarLinkClass}`}
                            >
                                <div
                                    className={`text ${currentStyling.navbarTextClass}`}
                                >
                                    {getText('msg_2544899993ff')}
                                </div>
                            </NavLink>
                        )}
                        {hasSecurityAttribute([
                            SecurityAttributes.VendorFullAccess,
                            SecurityAttributes.VendorFullAccessReadOnly,
                        ]) && (
                            <NavLink
                                to={ROUTES.VENDORS}
                                className={`${currentStyling.navbarLinkClass}`}
                            >
                                <div
                                    className={`text ${currentStyling.navbarTextClass}`}
                                >
                                    {getText('msg_634d89417f97')}
                                </div>
                            </NavLink>
                        )}
                        {hasSecurityAttribute([
                            SecurityAttributes.PlanDetailFullAccess,
                            SecurityAttributes.PlanDetailReadOnly,
                        ]) && (
                            <NavLink
                                to={ROUTES.PLAN_DETAILS}
                                className={`${currentStyling.navbarLinkClass}`}
                            >
                                <div
                                    className={`text ${currentStyling.navbarTextClass}`}
                                >
                                    {getText('msg_49f6b730623e')}
                                </div>
                            </NavLink>
                        )}
                    </div>
                </>
            )}

            <button
                className="dropdown-btn"
                onClick={event => toggleDropdown(event)}
            >
                <i
                    className="bi bi-question-circle"
                    style={{ color: currentStyling.accessoriesFg1 }}
                />
                <div className="text">{getText('msg_87df60de337f')}</div>
                <i className="bi bi-chevron-down dropdown-chevron" />
            </button>
            <div className="dropdown-container">
                {hasSecurityAttribute([
                    SecurityAttributes.ResourceLibraryFullAccess,
                ]) && (
                    <NavLink
                        to={ROUTES.RESOURCES}
                        className={`${currentStyling.navbarLinkClass}`}
                    >
                        <div
                            className={`text ${currentStyling.navbarTextClass}`}
                        >
                            {getText('msg_17760bc41bd4')}
                        </div>
                    </NavLink>
                )}

                <NavLink
                    to={ROUTES.HQ_TRAINING}
                    className={`${currentStyling.navbarLinkClass}`}
                >
                    <div className={`text ${currentStyling.navbarTextClass}`}>
                        {getText('msg_b6fe7f5e7917')}
                    </div>
                </NavLink>
            </div>

            {hasSecurityAttribute([
                SecurityAttributes.AgencyFullAccess,
                SecurityAttributes.AgencyReadOnly,
            ]) && (
                <NavLink
                    to={ROUTES.AGENCIES}
                    className={`${currentStyling.navbarLinkClass}`}
                >
                    <i className={`bi bi-globe`}></i>
                    <div className={`text ${currentStyling.navbarTextClass}`}>
                        {getText('msg_70c7e69a5f14')}
                    </div>
                </NavLink>
            )}

            {hasSecurityAttribute([
                SecurityAttributes.MultiImportQueueAccess,
                SecurityAttributes.MultiImportQueueEnhancedReviewAccess,
            ]) && (
                <NavLink
                    to={ROUTES.MULTITENANT_IMPORT_QUEUE}
                    className={`${currentStyling.navbarLinkClass}`}
                >
                    <i className={`bi bi-cloud-upload`}></i>
                    <div className={`text ${currentStyling.navbarTextClass}`}>
                        {getText('msg_e42328ac01cd')}
                    </div>
                </NavLink>
            )}

            {hasSecurityAttribute([
                SecurityAttributes.GlobalSSOFullAccess,
                SecurityAttributes.GlobalSSOReadOnly,
            ]) && (
                <NavLink
                    to={ROUTES.SSO_LIST}
                    className={`${currentStyling.navbarLinkClass}`}
                >
                    <i
                        className={`bi bi-key`}
                        style={{ color: currentStyling.accessoriesFg1 }}
                    ></i>
                    <div className={`text ${currentStyling.navbarTextClass}`}>
                        {getText('msg_a9f87647033f')}
                    </div>
                </NavLink>
            )}

            {hasSecurityAttribute([
                SecurityAttributes.BillingFullAccess,
                SecurityAttributes.BillingReadOnly,
            ]) && (
                <>
                    <button
                        className="dropdown-btn"
                        onClick={event => toggleDropdown(event)}
                    >
                        <i
                            className="bi bi-currency-dollar"
                            style={{ color: currentStyling.accessoriesFg1 }}
                        ></i>
                        <div className={`text`}>
                            {getText('msg_abaec4522bf6')}
                        </div>
                        <i className="bi bi-chevron-down dropdown-chevron" />
                    </button>
                    <div className="dropdown-container">
                        <NavLink
                            to={ROUTES.BILLING_CLIENTS}
                            className={`${currentStyling.navbarLinkClass}`}
                        >
                            <div
                                className={`text ${currentStyling.navbarTextClass}`}
                            >
                                {getText('msg_28e22fe3dde5')}
                            </div>
                        </NavLink>
                    </div>
                </>
            )}
        </>
    );
}

export default MultiTenantMenu;
